import React from 'react'
import Loader from '../../../components/Loader'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Responsive from '../../../assets/config/Responsive'
import FraniBackgroundIcon from '../../../assets/v2/JSX/FraniBackgroundIcon'
import { parseISO } from 'date-fns'
import Title from '../../../components/v2/Title'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useNavigate } from 'react-router-dom'
import DatePicker from '../../../components/v2/DatePicker'
import { useTranslation } from 'react-i18next'
import { CriticalIllnessState, setChooseDays, setDates } from '../../../store/criticalIllnessSlice'
import { useAppDispatch, useAppSelector } from '../../../store'
import dayjs from 'dayjs'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import api from '../../../api'
import { AppState } from '../../../store/appSlice'

const CriticalStartDate = () => {
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-insurance-period')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  const listItems = pageInfo?.listItems?.slice().sort((a, b) => a.sort - b.sort)
  //
  const leftCompanies = {
    companiesCount: 2,
  }
  //
  const mainLoading = isPageInfoLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <CriticalProgressbar stepName={stepName} />

        <FlexBlock>
          <Cards>
            {listItems?.map((item) => {
              let year = item?.title?.split(' ')[0]
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={item?.id}
                  imgCHildren={
                    <>
                      <FraniBackgroundIconStyle />
                      <div className="icon-days">{year}</div>
                    </>
                  }
                  title={item?.translations?.[lang]?.title}
                  selected={year === filter.chooseDays ? true : false}
                  onClick={() => {
                    if (filter.dates?.start && filter.dates?.end && filter.chooseDays !== year.toString()) {
                      dispatch(
                        setDates({
                          start: null,
                          end: null,
                        }),
                      )
                      dispatch(setChooseDays(year.toString()))
                    } else {
                      dispatch(setChooseDays(year.toString()))
                    }
                  }}
                >
                  {year.toString() === filter.chooseDays && (
                    <CalendarBox>
                      <hr />
                      <DatePicker
                        minDate={new Date()}
                        // maxDate={parseISO(maxDate) || undefined}
                        className="multi-start-date-class"
                        label={`${t('startDate')}`}
                        dateFormat="dd MMMM yyyy"
                        open={true}
                        selectedDate={filter.dates?.start ? parseISO(filter.dates.start as string) : null}
                        onchange={(value) =>
                          dispatch(
                            setDates({
                              start: dayjs(value).format('YYYY-MM-DD'),
                              end: dayjs(value).add(Number(year), 'year').format('YYYY-MM-DD'),
                            }),
                          )
                        }
                      />
                    </CalendarBox>
                  )}
                </HorizontalCard>
              )
            })}
          </Cards>

          <RemainingCompanies
            style={{
              opacity: leftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.companiesCount} `}
          />
        </FlexBlock>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/category')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={filter.dates?.start === null && filter.dates?.end === null ? true : false}
            onClick={() => [navigate('/critical-choose-currency')]}
          />
        </Buttons>
      </Content>
      <BackgroundIcon />
    </Wrapper>
  )
}
//
const FraniBackgroundIconStyle = styled(FraniBackgroundIcon)`
  height: 72px;

  ${Responsive.mobile} {
    height: 64px;
  }
`
const CalendarBox = styled.div`
  width: 100%;
  .react-datepicker-popper {
    position: unset !important;
    transform: unset !important;
    margin-top: 10px;
  }
  .react-datepicker {
    display: flex;
    justify-content: center;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
`
const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  max-width: 464px;
  width: 100%;

  .image-div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .icon-days {
    position: absolute;
    top: 61px;
    font-size: 16px;
    color: ${Colors.primaryBlack};
    user-select: none;
  }

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .icon-days {
      top: 62px;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const FlexBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 464px;
  width: 100%;
`

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`

export default CriticalStartDate
